import {defineAsyncComponent} from 'vue';
import popupUtil from '@/commons/popupUtil.js';

// Phân phối thu thi hành án
const popupJusticeReceiptDetail = defineAsyncComponent(() =>
  import('@/views/distribution/justiceReceipt/JusticeReceiptDetail.vue'),
);
const popupJusticeVoucherTranfer = defineAsyncComponent(() =>
  import('@/views/distribution/JusticeVoucherTranfer.vue'),
);


export function registerDistribution(app) {
  app.component('JusticeReceiptDetail', popupJusticeReceiptDetail);
  app.component('JusticeVoucherTranfer', popupJusticeVoucherTranfer);
}
export function registerAsset(app) {
    const registerConfig = {
      JusticeReceiptDetail: popupJusticeReceiptDetail,
    };
  
    const keys = Object.keys(registerConfig);
  
    keys.filter(key => {
      app.component(key, registerConfig[key]);
    });
  
    popupUtil.registerPopup(keys, 'Distribution');
  }